import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-footer-base',
  standalone: true,
  imports: [
    NgForOf,
    TranslatePipe,
  ],
  templateUrl: './footer-base.component.html',
  styleUrl: './footer-base.component.scss'
})
export class FooterBaseComponent {
  socialMediaLinks = [
    {name: 'Twitter', iconPath: 'assets/svgs/icons/social-media/x.svg', url: '#'},
    {name: 'LinkedIn', iconPath: 'assets/svgs/icons/social-media/linkedin.svg', url: 'https://www.linkedin.com/company/atrizult-practical-consulting'},
    {name: 'Facebook', iconPath: 'assets/svgs/icons/social-media/facebook.svg', url: 'https://www.facebook.com/profile.php?id=61589447625453'},
    {name: 'Instagram', iconPath: 'assets/svgs/icons/social-media/instagram.svg', url: '#'}
  ];
}
